import { render, staticRenderFns } from "./bookAssess.vue?vue&type=template&id=0a5b09b4&scoped=true"
import script from "./bookAssess.vue?vue&type=script&lang=js"
export * from "./bookAssess.vue?vue&type=script&lang=js"
import style0 from "./bookAssess.vue?vue&type=style&index=0&id=0a5b09b4&prod&scoped=true&lang=scss"
import style1 from "./bookAssess.vue?vue&type=style&index=1&id=0a5b09b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b09b4",
  null
  
)

export default component.exports